import {useContext, useEffect, useRef} from "react";
import {getPostRoute} from "common/const";
import styles from "components/swiper/optionSwiper.module.scss";
import Head from "next/head";
import classNames from "classnames";
import ArrowLeftIcon from "images/icons/arrow_left_757575.svg";
import {Swiper, SwiperSlide} from "swiper/react";
import {swiperCustomAnimation} from "common/utils";
import ArrowRightIcon from "images/icons/arrow_right_757575.svg";
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import PostListContext from "context/PostListContext";
import PostOptionCard from "components/cards/palette/PostOptionCard";


export const OptionSwiper = (props) => {
    const {item, productOptions, postId, setModalState, renderItem, initialOffset} = props;

    const {setFeedOptionModalTarget} = useContext(PostListContext);

    const isMobile = true;

    const multiItems = productOptions.length > 1;

    const swiperRef = useRef(null);


    useEffect(() => {
        if (swiperRef.current) {
            const swiper = swiperRef.current.swiper;
            swiper.allowTouchMove = !!isMobile;
            if (isMobile && productOptions.length > 1) {
                swiper.params.slidesPerView = 1.3;
            } else {
                swiper.params.slidesPerView = 1;
            }

            if (isMobile && productOptions.length > 1) {
                swiper.params.slidesOffsetBefore = initialOffset === undefined ? 16 : initialOffset;
                swiper.params.slidesOffsetAfter = initialOffset === undefined ? 16 : initialOffset;
            } else {
                swiper.params.slidesOffsetBefore = 0;
                swiper.params.slidesOffsetAfter = 0;
            }
            swiper.update();
        }
    }, [isMobile]);

    const handleOptionClick = (option, itemIdx) => {
        setFeedOptionModalTarget({
            option: option,
            postId: postId,
            referralCode: item.user.code,
        });
        window.history.pushState({isFeedModalOpen: true}, null, getPostRoute(postId));
        setModalState && setModalState(val => val + 1);
    };

    const onSlideChange = (swiper) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'PostCardOptionSwiperSwipe',
            {
                activeIndex: swiper.activeIndex,
            }
        );
    };

    const prevButtonClass = `optionSwiperPrevButton${postId}`;
    const nextButtonClass = `optionSwiperNextButton${postId}`;

    return (
        <div className={styles.optionSwiperContainer}>
            <Head>
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,viewport-fit=cover" />
                {/*<meta name="viewport" content="width=device-width, minimal-ui" />*/}
            </Head>
            {
                (multiItems && !isMobile) &&
                <div className={classNames(styles.optionSwiperPrevButton, prevButtonClass)}>
                    <ArrowLeftIcon className={styles.optionArrow} viewBox="0 0 16 16" />
                </div>
            }
            <div className={classNames(styles.optionSwiperContentContainer, multiItems ? styles.optionSwiperContentContainerSingleItem : undefined)}>
                <Swiper
                    ref={swiperRef}
                    spaceBetween={10}
                    onActiveIndexChange={(swiper) => {
                        props.optionSwiperIndex[postId] = swiper.activeIndex;
                    }}
                    onSetTranslate={swiperCustomAnimation}
                    navigation={{
                        prevEl: `.${prevButtonClass}`,
                        nextEl: `.${nextButtonClass}`,
                        disabledClass: styles.disabledOptionNavButton,
                    }}
                    initialSlide={props.optionSwiperIndex[postId] || 0}
                    allowTouchMove={false}
                    threshold={0}
                    slidesPerView={1}
                    onSlideChange={onSlideChange}
                >
                    <div>
                        {
                            productOptions.map((productOption, itemIdx) => {
                                return (
                                    <SwiperSlide key={productOption.id}>
                                        {
                                            renderItem
                                                ? renderItem(productOption, itemIdx)
                                                : <PostOptionCard
                                                    postId={postId}
                                                    productOption={productOption}
                                                    itemIdx={itemIdx}
                                                    handleOptionClick={handleOptionClick}
                                                />
                                        }
                                    </SwiperSlide>
                                );
                            })
                        }
                    </div>
                </Swiper>
            </div>
            {
                (multiItems && !isMobile) &&
                <div className={classNames(styles.optionSwiperNextButton, nextButtonClass)}>
                    <ArrowRightIcon className={styles.optionArrow} viewBox="0 0 12 12" width={24} height={24} />
                </div>
            }
        </div>

    );
}
